import {
	LineChart,
	Line,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	ResponsiveContainer,
	ReferenceLine,
	Legend,
	Label,
} from 'recharts'
import EixY from './EixY'
import EixX from './EixX'
import TooltipInfo from './TooltipInfo'
// import PercentUsuari from './PercentUsuari'
import PercentSou from './PercentSou'
import Llegenda from './Llegenda'
import { calculCentil, calculCentilComunitat, formatEnter } from '../utils'

const Grafic = ({ dadesForm, percentils, tipus, textos }) => {
	// Dades formulari
	const { comunitat, sou } = dadesForm

	// Dades
	const mitjana = formatEnter(
		percentils.find((centil) => centil.centil === 50)?.sme_total || 0
	)
	const percentil =
		tipus === 'total'
			? calculCentil(sou)
			: calculCentilComunitat(sou, comunitat)

	const fonsVertical = Array(10)
		.fill(0)
		.map((_, i) =>
			i + 1 === Math.ceil(percentil / 10) ? '#FFB215' : 'transparent'
		)

	return (
		<>
			<ResponsiveContainer width='100%' height={417}>
				<LineChart
					width={600}
					height={417}
					margin={{ top: 20, right: 5, left: 5, bottom: 0 }}
					data={percentils}
				>
					{mitjana && (
						<Legend
							verticalAlign='bottom'
							content={<Llegenda mitjana={mitjana} textos={textos} />}
							width='fit-content'
							wrapperStyle={{
								left: 'calc(50% - 2.5px)',
								transform: 'translateX(-50%)',
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
							}}
						/>
					)}
					<CartesianGrid
						verticalFill={fonsVertical}
						fillOpacity={0.15}
						strokeDasharray='1 0'
						stroke='#D8E0E8'
					/>
					<XAxis
						tickLine={false}
						dataKey='centil'
						ticks={[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
						tick={<EixX />}
						minTickGap={0}
					>
						<Label
							content={() => (
								<text x={5} y={345} fill='#888' className='e6'>
									0
								</text>
							)}
						/>
					</XAxis>
					<YAxis
						tickLine={false}
						axisLine={false}
						mirror={true}
						tick={<EixY />}
						domain={[0, 180000]}
					/>
					<Line
						type='step'
						dataKey='sme_total'
						stroke='#000'
						strokeWidth={2}
						dot={false}
					/>
					<ReferenceLine
						stroke='#000'
						strokeDasharray='3 3'
						ifOverflow='visible'
						segment={[
							{ x: 50, y: -10000 },
							{ x: 50, y: 180000 },
						]}
					/>
					<ReferenceLine
						x={percentil}
						stroke='#FFB215'
						strokeWidth={2}
						label={({ viewBox }) => (
							<PercentSou
								viewBox={viewBox}
								percentil={percentil}
								textos={textos}
							/>
						)}
					/>

					<Tooltip content={<TooltipInfo textos={textos} />} />
				</LineChart>
			</ResponsiveContainer>
			<div className='peu-grafic mt-A e6'>
				<p
					dangerouslySetInnerHTML={{
						__html: textos.llegenda,
					}}
				></p>
				<p>{textos.font}</p>
			</div>
		</>
	)
}
export default Grafic
